// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://fqtpbtmghmhpntqlhthi.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImZxdHBidG1naG1ocG50cWxodGhpIiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODQ4MTMyMTAsImV4cCI6MjEwMDM4OTIxMH0.lQIuPkOYVGVtwcWCl2wKSoV_N3x91f0WhhYSRozNdjQ";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});